// src/components/Services.jsx
import React from 'react';
import CTAButton from './CTAButton';

const Services = () => {
    const services = [
        {
            id: 1,
            title: "Express Wash",
            description: "Quick exterior wash and basic interior cleaning",
            startingPrice: "$50",
            image: "/images/premium-detail.jpg" // Update with your image path
        },
        {
            id: 2,
            title: "Premium Detail",
            description: "Thorough interior and exterior cleaning with wax application",
            startingPrice: "$70",
            image: "/images/premium-detail.jpg"
        },
        {
            id: 3,
            title: "Full Interior & Exterior",
            description: "Complete deep cleaning and restoration for your vehicle",
            startingPrice: "$140",
            image: "/images/premium-detail.jpg"
        }
    ];

    const handleDownloadPricing = () => {
        const pdfUrl = "/pricing-details.pdf";
        window.open(pdfUrl, '_blank');
    };

    return (
        <section id="services" className="services section">
            <div className="container">
                <div className="section-header">
                    <h2 className="section-title">Our Services</h2>
                    <p className="section-subtitle">No waiting rooms. No hassle. Just professional-grade detailing — delivered to your driveway.</p>
                </div>

                <div className="services-grid">
                    {services.map(service => (
                        <div key={service.id} className="service-card">
                            <h3 className="service-title">{service.title}</h3>

                            <div className="price-container">
                                <span className="starting-from">Starting from</span>
                                <span className="price">{service.startingPrice}</span>
                            </div>

                            <p className="service-description">{service.description}</p>

                            {/* Service Image */}
                            <div className="service-image-container">
                                <img
                                    src={service.image}
                                    alt={service.title}
                                    className="service-image"
                                />
                            </div>

                            <CTAButton
                                text="Book This Service"
                                size="small"
                                className="service-button"
                            />
                        </div>
                    ))}
                </div>

                {/* Separate Pricing Button */}
                <div className="pricing-button-container">
                    <CTAButton
                        text="View Pricing"
                        onClick={handleDownloadPricing}
                        className="pricing-button"
                    />
                </div>
            </div>
        </section>
    );
};

export default Services;